'use strict';

var Backbone = require('backbone');
var Radio = require('backbone.radio');
var _ = require('underscore');
var $ = require('jquery');

var SubmitView = require('./submit').default;
var stripe = require('../../utilities/stripe').default;
var polyglot = require('../../utilities/polyglot').default;

var Card = require('../../models/card').default;

var TitleView = require('../step-title').default;
var SummaryView = require('../appointments/summary').default;
var FormView = require('../cards/form').default;

export default SubmitView.extend({

  className: 'l-payment-step',
  template: require('./templates/payment.hbs'),
  defaultErrorMessage: polyglot.t('payment.error'),

  regions: function () {
    return {
      title: '.' + this.className + '-title',
      summary: '.' + this.className + '-summary',
      form: '.' + this.className + '-form',
    };
  },

  initialize: function (options) {
    stripe.setPublishableKey(window.SETTINGS.stripe_public_key);

    this.titleView = new TitleView({
      title: polyglot.t('pages.payment.long_title'),
    });

    this.summaryView = new SummaryView({
      model: this.appointment,
    });

    this.formView = new FormView({
      model: new Card(),
    });

    this.listenTo(this.formView, 'submit', this.onFormSubmit);
  },

  onRender: function () {
    this.getRegion('title').show(this.titleView);
    this.getRegion('summary').show(this.summaryView);
    this.getRegion('form').show(this.formView);
  },

  onDomRefresh: function () {
    this.formView.focus();
  },

  onFormSubmit: function (card) {
    try {
      stripe.card.createToken(card.attributes, _.bind(this.onStripeResponse, this));
    } catch (e) {
      this.formView.showError(polyglot.t('something_went_wrong'), 'number');
      this.formView.enableSubmit();
    }
  },

  onStripeResponse: function (status, response) {
    if (response.error) {
      this.formView.hideErrors();
      let key = `forms.stripe_error.${response.error.decline_code}`;
      let message = polyglot.t(key);
      // message is not found
      if (message === key) {
        key = response.error.param ? 'forms.error' : 'forms.stripe_error.generic';
        message = polyglot.t(key);
      }
      Radio.channel('toast').trigger('show', {
        message,
        iconColor: 'error',
      });
      if (response.error.param) {
        this.formView.showError(polyglot.t(response.error.code), response.error.param);
      }
      this.formView.enableSubmit();
    } else {
      this.appointment.set('client_timezone', window.localStorage.getItem('timezone'));

      if (window.REQUEST_START) {
        this.appointment.set('booked_through', window.CONSTANTS.ORIGIN_WAIT_LIST);
        this.appointment.set('request_id', window.REQUEST.id);
      }

      if (typeof this.appointment.get('start') !== 'string') {
        const start = this.appointment.get('start')
          .tz(this.appointment.getLocation().get('timezone'))
          .format('YYYY-MM-DD HH:mm:ss');
        this.appointment.set('start', start);
      }

      this.appointment.set('stripe_token', response.id);
      this.appointment.save({
        _token: $('meta[name="csrf-token"]').attr('content'),
      })
        .done(_.bind(this.onSaveSuccess, this))
        .fail(_.bind(this.onSaveError, this));
    }
  },

});
